import { Entity } from "@models/Entity";
import type { FeatureErrorMapper } from "./types";

/**
 * Feature error mappers register here (from the app composition root) so this
 * infra layer never imports features. `messageFor()` reads it via the getter.
 */
const registry: Partial<Record<Entity, FeatureErrorMapper>> = {};

export function registerFeatureErrorMapper(
  entity: Entity,
  mapper: FeatureErrorMapper
): void {
  registry[entity] = mapper;
}

export function getFeatureErrorMapper(
  entity: Entity
): FeatureErrorMapper | undefined {
  return registry[entity];
}
